import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center group",
      className
    )}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-3 w-full grow rounded-full bg-gradient-to-r from-muted/60 via-muted/40 to-muted/60 shadow-inner border border-border/20 backdrop-blur-sm overflow-hidden">
      <SliderPrimitive.Range className="absolute h-full bg-gradient-to-r from-primary/95 via-primary to-primary/90 rounded-full shadow-[0_0_16px_hsl(var(--primary)/0.3)] transition-all duration-300 ease-out group-hover:shadow-[0_0_20px_hsl(var(--primary)/0.5)] backdrop-blur-sm" />
    </SliderPrimitive.Track>
    {Array.from({ length: props.value?.length || 1 }).map((_, index) => (
      <SliderPrimitive.Thumb 
        key={index}
        className="block h-6 w-6 rounded-full border-2 border-primary bg-gradient-to-br from-background via-background/95 to-background/80 shadow-[0_4px_16px_hsl(var(--primary)/0.25),0_2px_8px_rgba(0,0,0,0.1)] ring-offset-background transition-all duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:scale-110 hover:border-primary hover:shadow-[0_6px_20px_hsl(var(--primary)/0.4),0_3px_12px_rgba(0,0,0,0.15)] active:scale-95 cursor-grab active:cursor-grabbing relative z-10 backdrop-blur-sm before:absolute before:inset-0 before:rounded-full before:bg-gradient-to-br before:from-primary/15 before:via-primary/10 before:to-transparent before:opacity-0 hover:before:opacity-100 before:transition-opacity before:duration-300 after:absolute after:inset-[3px] after:rounded-full after:bg-gradient-to-br after:from-white/20 after:to-transparent after:opacity-30" 
      />
    ))}
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }